module.exports = __webpack_public_path__ + "static/media/interdocs.b9b4a00d.jpg";